import { render, staticRenderFns } from "./AddBestellingdag.vue?vue&type=template&id=7d766f74&scoped=true&"
import script from "./AddBestellingdag.vue?vue&type=script&lang=js&"
export * from "./AddBestellingdag.vue?vue&type=script&lang=js&"
import style0 from "./AddBestellingdag.vue?vue&type=style&index=0&id=7d766f74&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d766f74",
  null
  
)

export default component.exports